import { Sparkles } from "lucide-react";

/**
 * RenderedBadge — tiny luxury pill shown over images that were generated by
 * Facetra's pipeline (vs stock photography). Use sparingly: only on tiles
 * where the visual is a real Gemini Nano Banana / studio render.
 */
export default function RenderedBadge({ className = "", compact = false }) {
  return (
    <span
      data-testid="rendered-by-facetra-badge"
      className={`pointer-events-none inline-flex items-center gap-1 bg-black/55 backdrop-blur-md border border-[#D4AF37]/35 text-[#D4AF37] rounded-full ${
        compact ? "px-1.5 py-0.5 text-[8.5px]" : "px-2 py-0.5 text-[9px]"
      } uppercase tracking-[0.18em] shadow-[0_4px_12px_-4px_rgba(0,0,0,0.45)] ${className}`}
    >
      <Sparkles className={compact ? "w-2.5 h-2.5" : "w-3 h-3"} />
      Rendered&nbsp;by&nbsp;Facetra
    </span>
  );
}
